<template>
  <div class="v_all_all">
    <div class="v_all_background">
      <div class="v_search_div">
        <label class="v_search_label">纪念堂名称：</label>
        <el-input class="v_search_input" v-model="deadManName"></el-input>
        <el-button
          class="v_search_button"
          type="primary"
          @click="findSpaceList()"
          >搜索</el-button
        >
      </div>
      <div class="v_top_line"></div>
      <!-- @click="sweepShowClick(spaceDetailData.id)" -->
      <div v-for="(spaceDetailData, i) in list" :key="i" class="v_space">
        <div class="v_space_title">
          <div class="v_space_left">纪念堂名称：</div>
          <div
            class="v_space_name"
            @click="showDeadInfoDialog(spaceDetailData)"
          >
            {{ spaceDetailData.name }}
          </div>
        </div>
        <!-- <div class="v_space_title">
          纪念堂编号：<span class="v_space_name">{{
            spaceDetailData.codeNew
          }}</span>
        </div> -->
        <div class="v_space_title">
          创建日期：<span class="v_space_name_black">{{
            spaceDetailData.createTimeNew
          }}</span>
        </div>
        <div class="v_space_title">
          有效期至：<span class="v_space_name_black">{{
            spaceDetailData.foreverState == 1
              ? "永久"
              : spaceDetailData.closeTimeNew
          }}</span>
        </div>
        <div class="v_space_title">
          纪念堂状态：<span class="v_space_name_black">{{
            spaceDetailData.stateNew
          }}</span
          ><span
            class="v_space_name_black_red"
            v-if="spaceDetailData.spaceFrozen == 1"
            >{{ spaceDetailData.stateCold }}</span
          >
        </div>
        <div class="v_space_title">
          <div class="v_space_left">纪念堂认领：</div>
          <div class="v_space_name_black">
            {{ spaceDetailData.claimStateStr }}
          </div>
        </div>
        <div class="v_space_title">
          <div class="v_space_left">经手：</div>
          <div class="v_space_name_black">
            {{ spaceDetailData.unitShortNames }}
          </div>
        </div>
        <div class="v_top_line"></div>
      </div>
      <!-- 纪念堂备注 -->
      <div
        class="v_dialog_background"
        v-if="showOtherInfos"
        @click.stop="cancleDeathInfo()"
        @touchmove.prevent
      ></div>
      <div class="v_remark_middle" @touchmove.prevent v-if="showOtherInfos">
        <div class="title">备注信息</div>
        <div class="cell_area">
          <div class="cell_line">
            <div class="cell_title" style="letter-spacing: 4px">逝者姓名</div>
            <div>：</div>
            <div ref="cell_content" class="cell_content">{{ deadName }}</div>
          </div>
          <div class="cell_line">
            <div class="cell_title">
              <span style="float: left">生</span
              ><span style="float: right; margin-right: 10px">辰</span>
            </div>
            <div>：</div>
            <div ref="cell_content" class="cell_content">
              {{ deadBirthday }}
            </div>
          </div>
          <div class="cell_line">
            <div class="cell_title">
              <span style="float: left">忌</span
              ><span style="float: right; margin-right: 10px">辰</span>
            </div>
            <div>：</div>
            <div ref="cell_content" class="cell_content">
              {{ deadDeathay }}
            </div>
          </div>
          <div class="cell_line">
            <div class="cell_title">主办人姓名</div>
            <div>：</div>
            <div ref="cell_content" class="cell_content">{{ hostName }}</div>
          </div>
          <div class="cell_line">
            <div class="cell_title">主办人手机</div>
            <div>：</div>
            <div ref="cell_content" class="cell_content">{{ hostNameTel }}</div>
          </div>
          <div class="cell_line">
            <div class="cell_title">
              <span style="float: left">访</span>
              <span style="margin-left: 16px">问</span>
              <span style="float: right; margin-right: 5px">码</span>
            </div>
            <div>：</div>
            <div ref="cell_content" class="cell_content">
              <img
                class="v_remark_wxcode"
                :src="wxAcodeUrl"
                @click="showWxAcodeUrl"
              />
            </div>
          </div>
        </div>

        <div class="line"></div>
        <div class="btn" @click.stop="cancleDeathInfo()">确定</div>
      </div>
    </div>
    <div v-if="!haveData" class="v_have_no_data">
      <img
        src="@/assets/images/personal/iv_have_no.png"
        alt=""
        class="iv_no_data"
      />
      <div class="v_no_data_text">未找到纪念堂</div>
    </div>
    <div v-if="sweepShow" class="v_sweep">
      <div class="v_sweep_return">
        <el-button
          class="v_sweep_return_button"
          type=""
          @click="sweepHideClick()"
          >返回</el-button
        >
      </div>
      <div class="v_sweep_next">
        <el-button
          class="v_sweep_next_button"
          type="success"
          @click="sweepNextTouchstart"
          @touchstart="sweepNextTouchstart"
          @touchend="sweepNextTouchend"
          >下一步</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      code: "",
      url: "/api",
      loginData: {},
      deadManName: "",
      list: [],
      loadingAll: "",
      haveData: true,
      sweepShow: false,
      dmId: 0,
      timer: null,
      //纪念堂备注信息
      showOtherInfos: false,
      deadName: "",
      deadBirthday: "",
      deadDeathay: "",
      hostName: "",
      hostNameTel: "",
      wxAcodeUrl: "",
    };
  },
  created() {
    if (true) {
      //return;
    }
    this.loadingAll = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    let link = window.location.href;
    let links = link.split("code=");
    let linksA = links[1].split("&state=");
    this.code = linksA[0];
    this.getLoginWxEnterprise();
  },
  computed: {},

  mounted() {},

  methods: {
    //SpringSecurity企微登录
    getLoginWxEnterprise() {
      let that = this;
      let postData = new FormData();
      postData.append("code", this.code);
      let testRequest = new Request(this.url + "/loginWxEnterprise", {
        method: "POST",
        body: postData,
      });
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          //JSON.stringify(res);
          if (res.status == 1000) {
            this.loginData = res.data;
          } else if (res.status == 1004) {
            that.$message.error("当前登录账户已禁用");
          } else if (res.status == 1027) {
            that.$message.error("您的权限已发生变更，如有问题请联系中枢");
            this.getLoginWxEnterprise();
            return;
          } else {
            that.$message.error("获取信息失败，请检查网络连接");
          }
          that.loadingAll.close();
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    //查询纪念堂
    findSpaceList() {
      let that = this;
      if (that.deadManName.trim().length == 0) {
        return;
      }
      this.loadingAll = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let testRequest = new Request(this.url + "/bygDeadManV2/find", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json;charset=UTF-8;",
        },
        body: JSON.stringify({
          data: { nameOrremarkName: that.deadManName },
          pageInfo: {
            page: 1,
            size: 200,
            total: 0,
          },
        }),
      });
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            if (res.pageInfo.total > 0) {
              res.data.forEach((_t) => {
                console.log();
                debugger;
                let arr = _t.code.split("");
                let arrs = [];
                let codeNew = "";
                while (arr.length > 0) {
                  let arrThis = arr.splice(0, 4);
                  let strThis = arrThis.join("");
                  arrs.push(strThis);
                }
                codeNew = arrs.join(" ");
                _t.codeNew = codeNew;
                _t.createTimeNew =
                  _t.createTime.substring(0, 4) +
                  "/" +
                  _t.createTime.substring(5, 7) +
                  "/" +
                  _t.createTime.substring(8, 10);
                _t.closeTimeNew =
                  _t.closeTime.substring(0, 4) +
                  "/" +
                  _t.closeTime.substring(5, 7) +
                  "/" +
                  _t.closeTime.substring(8, 10);

                if (_t.foreverState == 1) {
                  _t.stateNew = "永久";
                } else {
                  if (_t.status == 2) {
                    _t.stateNew = "过期";
                  } else if (_t.status == 1) {
                    if (_t.closeTimeState == 1) {
                      _t.stateNew = "即将到期";
                    } else {
                      _t.stateNew = "有效";
                    }
                  }
                }
                if (_t.spaceFrozen == 1) {
                  _t.stateCold = "冻结";
                }
                if (_t.claimState == 1) {
                  _t.claimStateStr = "是";
                } else {
                  _t.claimStateStr = "否";
                }
              });
              that.list = res.data;
              that.haveData = true;
            } else {
              that.haveData = false;
            }
            that.loadingAll.close();
          } else {
            that.loadingAll.close();
            that.$message.error("获取信息失败，请检查网络连接");
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //纪念堂备注信息-显示
    showDeadInfoDialog(objThis) {
      this.loadingAll = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.showOtherInfos = true;
      this.deadName = objThis.remarkName ? objThis.remarkName : "";
      this.deadBirthday = objThis.remarkBirthday ? objThis.remarkBirthday : "";
      this.deadDeathay = objThis.remarkDeadday ? objThis.remarkDeadday : "";
      this.hostName = objThis.undertakerName ? objThis.undertakerName : "";
      let that = this;
      let testRequest = new Request(
        this.url + "/bygDeadManV2/findWxEnterpriseRemarkById",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
          },
          body: JSON.stringify({
            data: objThis.id,
          }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            that.wxAcodeUrl = res.data.wxAcodeUrl;
            that.hostNameTel = res.data.undertakerTel;
          }else{
            that.$message.error("获取信息失败，请检查网络连接");
          }
          that.loadingAll.close();
        })
        .catch(function (err) {
          console.log(err);
          that.$message.error("获取信息失败，请检查网络连接");
          that.loadingAll.close();
        });
    },
    //纪念堂备注信息-隐藏
    cancleDeathInfo() {
      this.showOtherInfos = false;
      this.deadName = "";
      this.deadBirthday = "";
      this.deadDeathay = "";
      this.hostName = "";
      this.hostNameTel = "";
      this.wxAcodeUrl = "";
    },
    showWxAcodeUrl(img) {
      if (img.target.classList.contains("v_remark_wxcode_zoomed")) {
        // 如果已放大，移除zoomed类以恢复原始大小
        img.target.classList.remove("v_remark_wxcode_zoomed");
      } else {
        // 如果未放大，添加zoomed类以放大图片
        img.target.classList.add("v_remark_wxcode_zoomed");
      }
    },
    //显示控制扫墓页面
    sweepShowClick(dmId) {
      this.sweepShow = true;
      this.dmId = dmId;
    },
    sweepHideClick() {
      this.sweepShow = false;
    },
    sweepNextTouchstart() {
      if (true) {
        this.sweepNextClick();
        return;
      }
      this.timer = setTimeout(() => {
        this.timer = null;
        this.sweepNextClick();
      }, 2000);
    },
    sweepNextTouchend() {
      clearTimeout(this.timer);
      this.timer = null;
    },
    sweepNextClick() {
      let data = {
        data: this.dmId,
      };
      let headers = {
        "Content-Type": "application/json;charset=UTF-8;",
      };
      let request = new Request("/api/bygDeadManSweep/next", {
        method: "POST",
        credentials: "include",
        headers: headers,
        body: JSON.stringify(data),
      });
      fetch(request)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            this.$message({
              message: "操作成功",
              type: "success",
              center: true,
            });
          } else {
            that.$message.error("获取信息失败，请检查网络连接");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.v_all_all {
  background-color: #F7F8F9;
}

.v_all_background {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background-color: #ffffff;

  &::-webkit-scrollbar {
    display: none;
  }
}

.v_top_line {
  width: 100%;
  height: 10px;
  background: #F7F8F9;
}

.v_search_div {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.v_search_label {
  width: 186px;
  text-align: right;
}

.v_search_input {
  width: 100vw;
}

.v_search_button {
  /* line-height: 13px; */
  margin: 2px;
}

.v_space {
  background-color: #ffffff;
  margin-top: 15px;

  .v_space_title {
    margin-left: 18px;
    font-size: 16px;
    font-weight: 400;
    color: #949494;
    display: flex;
    flex-direction: row;
    margin-bottom: 15px;
  }

  .v_space_left {
    flex-shrink: 0;
  }

  .v_space_name {
    font-size: 16px;
    font-weight: 400;
    color: #F19100;
    margin-right: 12px;
    word-wrap: break-word;
    word-break: break-all;
  }

  .v_space_name_black {
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    margin-right: 10px;
  }

  .v_space_name_black_red {
    font-size: 16px;
    font-weight: 400;
    color: #EC2F2F;
    margin-right: 10px;
  }
}

.v_space_line {
  height: 15px;
}

.v_space_person_list {
  background-color: #ffffff;

  .v_space_person_title {
    margin-left: 18px;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }

  .v_space_person_number {
    height: 60px;
    line-height: 60px;
    font-size: 15px;
    font-weight: 400;
    color: #949494;
    margin-left: -5px;
  }
}

.v_line {
  background: #D5D5D5;
  height: 1px;
  width: 100%;
}

.v_space_person_item {
  background: #F7F8F9;
  margin-left: 18px;
  margin-right: 18px;
  padding-top: 15px;
  margin-top: 15px;
  width: auto;

  .v_space_person_item_top {
    margin-bottom: 15px;
    margin-left: 18px;
    display: flex;
    flex-direction: row;
  }

  .iv_space_person_item_img {
    width: 45px;
    height: 45px;
    border-radius: 5px;
    flex-shrink: 0;
  }

  .v_space_person_item_name {
    font-size: 25px;
    font-weight: 500;
    color: #000000;
    word-wrap: break-word;
    word-break: break-all;
    margin-right: 10px;
  }

  .v_space_person_item_title {
    margin-top: 5px;
    font-size: 13px;
    font-weight: 400;
    color: #949494;
    display: flex;
    flex-direction: row;
  }

  .v_space_person_item_result {
    font-size: 13px;
    font-weight: 400;
    color: #000000;
    word-wrap: break-word;
    word-break: break-all;
    margin-right: 10px;
  }

  .v_space_person_item_result_left {
    flex-shrink: 0;
  }
}

.v_space_person_item_line {
  margin-left: 15px;
  margin-right: 15px;
  width: auto;
  height: 1px;
  border-bottom: 1px dashed #949494;
}

.v_space_person_item_line_another {
  width: auto;
  height: 1px;
}

.v_space_person_item_bottom {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.v_space_person_item_button {
  width: 150px;
  height: 30px;
  background: linear-gradient(90deg, #FF9B5D 0%, #FFBB00 100%);
  box-shadow: 0px 8px 20px 1px #FFDDC3;
  border-radius: 22px;
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 30px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 15px;
}

.v_space_person_item_button_blue {
  width: 150px;
  height: 30px;
  background: linear-gradient(90deg, #418EEF 0%, #70CDFF 100%);
  box-shadow: 0px 8px 20px 1px #DFF3FE;
  border-radius: 22px;
  font-size: 16px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 30px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 15px;
}

.v_bottom_line {
  height: 10px;
}

.v_have_no {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 206px;

  .iv_have_no {
    width: 125px;
    height: 125px;
  }

  .v_have_no_text {
    margin-top: 20px;
    font-size: 15px;
    font-weight: 400;
    color: #949494;
  }
}

.v_have_no_data {
  position: fixed;
  left: 0;
  right: 0;
  top: 54px;
  bottom: 0;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;

  // justify-content: center;
  .iv_no_data {
    margin-top: 20vh;
    width: 125px;
    height: 125px;
    margin-bottom: 50px;
  }

  .v_no_data_text {
    font-size: 15px;
    font-weight: 400;
    color: #949494;
  }
}

.v_sweep {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .v_sweep_return {
    width: 100vw;
    text-align: left;
  }

  .v_sweep_next {
    width: 100vw;
    user-select: none;
    display: flex;
    flex-direction: column;
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中，如需要 */
    height: 100px; /* 容器高度 */
  }
}

.v_dialog_background {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background: #000000;
  opacity: 0.7;
}

.v_remark_middle {
  position: fixed;
  left: 22px;
  right: 22px;
  top: 100px;
  border-radius: 15px;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    width: 100%;
    height: 32px;
    font-size: 20px;
    font-weight: 500;
    color: #000000;
    line-height: 32px;
    text-align: center;
    padding: 30px 0 5px;
  }

  .cell_area {
    padding: 0 15px;
    display: inline-block;

    .cell_line {
      font-size: 16px;
      line-height: 22px;
      display: flex;
      flex-direction: row;
      margin-top: 15px;

      .cell_title {
        width: 84px;
        color: #949494;
        flex-shrink: 0;
      }

      .cell_content {
        min-width: 100px;
        word-break: break-all;
      }
    }
  }

  .line {
    width: 100%;
    height: 1px;
    background: #D8D8D8;
    margin-top: 40px;
  }

  .btn {
    width: 100%;
    height: 68px;
    font-size: 20px;
    font-weight: 500;
    color: #EF9400;
    line-height: 68px;
    text-align: center;
  }

  .v_remark_wxcode {
    width: 40px;
    height: 40px;
  }

  .v_remark_wxcode_zoomed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: none;
    background-color: rgba(0, 0, 0, 0.5);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/WxSweep/WxSweep.vue